import React, { useEffect, useState } from "react";
import { Radio, Heart } from "lucide-react";
import { ccBtnPink } from "../care/ui";
import { LiveViewer } from "./LiveEvents";

const API = process.env.REACT_APP_BACKEND_URL;

// Parent-facing live events strip — facility + public events the parent may view
export const ParentLiveSection = ({ currentUser }) => {
  const [events, setEvents] = useState([]);
  const [watching, setWatching] = useState(null);

  useEffect(() => {
    const load = () =>
      fetch(`${API}/api/live/active`, { credentials: "include" })
        .then((r) => (r.ok ? r.json() : []))
        .then(setEvents)
        .catch((err) => console.debug("live list failed", err));
    load();
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, []);

  if (!events.length && !watching) return null;

  return (
    <div className="mt-6 pt-6 border-t border-[#FCE6E9] dark:border-[#374457]" data-testid="parent-live-section">
      <p className="text-[10px] font-extrabold uppercase tracking-wider text-[#9CA3AF] mb-3 flex items-center gap-1.5">
        <Radio className="w-3.5 h-3.5 text-rose-400" /> Live Events
      </p>
      <div className="space-y-2">
        {events.map((ev) => (
          <div key={ev.id} className="flex items-center justify-between gap-3 bg-[#FFF9F2] border border-[#FCE6E9] rounded-2xl px-4 py-3 dark:bg-[#273244] dark:border-[#374457]" data-testid={`parent-live-${ev.id}`}>
            <div className="min-w-0">
              <p className="text-xs font-black text-[#374151] dark:text-slate-100 flex items-center gap-2 truncate">
                <span className="w-2 h-2 rounded-full bg-rose-500 animate-pulse shrink-0" /> {ev.title}
              </p>
              <p className="text-[11px] text-[#9CA3AF] font-medium">
                {ev.host_name} · {ev.facilityName} · <Heart className="w-3 h-3 inline -mt-0.5" /> {ev.hearts}
              </p>
            </div>
            <button onClick={() => setWatching(ev.id)} className={`${ccBtnPink} shrink-0`} data-testid={`parent-live-watch-${ev.id}`}>
              Watch Live
            </button>
          </div>
        ))}
      </div>
      {watching && <LiveViewer eventId={watching} currentUser={currentUser} onClose={() => setWatching(null)} />}
    </div>
  );
};
